import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskResponse } from '../models/task.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

/**
 * Opciones para abrir el drawer de tareas. Permite prefill cross-módulo:
 * cualquier listado/detalle de Contacto/Empresa/Deal/Lead puede abrir el drawer
 * con la asociación pre-seleccionada para que el usuario solo complete los detalles.
 */
export interface TaskDrawerOptions {
  taskId?: number;

  // Asociación pre-llenada (RF-10.02)
  contactId?: number;
  contactName?: string;
  companyId?: number;
  companyName?: string;
  dealId?: number;
  dealName?: string;
  leadId?: number;
  leadName?: string;

  // Subtarea de otra tarea
  parentTaskId?: number;
  parentTaskTitle?: string;

  // Prefill rápido
  initialDueDate?: string; // ISO string
  initialTitle?: string;
  initialTypeId?: number;
}

export interface TaskDrawerState {
  isOpen: boolean;
  options: TaskDrawerOptions;
}

@Injectable({ providedIn: 'root' })
export class TaskDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly stateSubject = new BehaviorSubject<TaskDrawerState>({
    isOpen: false,
    options: {}
  });
  readonly state$ = this.stateSubject.asObservable();

  private readonly savedSubject = new Subject<TaskResponse>();
  readonly saved$ = this.savedSubject.asObservable();

  open(options: TaskDrawerOptions = {}): void {
    if (!this.stateSubject.value.isOpen) this.registry.opened();
    this.stateSubject.next({ isOpen: true, options });
  }

  close(): void {
    if (this.stateSubject.value.isOpen) this.registry.closed();
    this.stateSubject.next({ isOpen: false, options: {} });
  }

  notifySaved(task: TaskResponse): void {
    this.savedSubject.next(task);
  }
}
